import { render, staticRenderFns } from "./look-dragon-activity.vue?vue&type=template&id=89551da2&scoped=true&"
import script from "./look-dragon-activity.vue?vue&type=script&lang=js&"
export * from "./look-dragon-activity.vue?vue&type=script&lang=js&"
import style0 from "./look-dragon-activity.vue?vue&type=style&index=0&id=89551da2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89551da2",
  null
  
)

export default component.exports